import { render, staticRenderFns } from "./CallbackShopify.vue?vue&type=template&id=8d07f57a"
import script from "./CallbackShopify.vue?vue&type=script&lang=ts"
export * from "./CallbackShopify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports